import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessChats } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { chatsRoutes } from "./routes";

export const chatsRoute = [
  {
    path: chatsRoutes.list,
    lazy: async () => {
      const { ChatListPage } = await import("./pages/list/ChatListPage");

      return {
        element: (
          <RequireAuth permission={canAccessChats}>
            <ChatListPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: chatsRoutes.details,
    lazy: async () => {
      const { ChatDetailPage } = await import("./pages/detail/ChatDetailPage");

      return { element: <ChatDetailPage /> };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
